// SHipping column, with forecast
import React from "react";
import ShippingForecastDisplay from "./ShippingForecastDisplay";
import AgentPriceInfo from "./AgentPriceInfo";

export default function CartItemShipping({item, forecast, cartConfig = {}, currentAgent}) {
  if (!item)
    return null;

  return <div className="col-span-2 col-shipping">
    <div className="shipping">
      <ShippingCostDisplay cartConfig={cartConfig} item={item}/>

      <ShippingForecastDisplay forecast={forecast}/>
      {currentAgent && <AgentPriceInfo item={item} currentAgent={currentAgent}/>}
    </div>
  </div>
}

function ShippingCostDisplay({cartConfig = {}, item={}}) {
  const {flatRateShipping} = cartConfig;

  let {effectiveShippingTotal = 0} = item;

  if (!effectiveShippingTotal) {
    return <div className="text-brand-secondary font-bold">Free Shipping</div>
  }

  if (flatRateShipping) return null;

  // // tags: list of strings like [ "prop65", "klaviyo-welcome1", ]
  // let delayed = _.includes(productGroup.tags, "covid-delay");
  //
  let shipDollars = new Money(effectiveShippingTotal);

  return <div className="text-left">{shipDollars.toString()}</div>
}


